export class HostingPasswordProtection {

  public username: string;
  public password: string;

}

